/*
    cookie policy
    Version:2
    Dependencies: jQuery
  
    SUMMARY:

    Controls cookie policy display setting and removing cookies. Currently built to work with RocktimeCore.config setting
    EnableNewStyleCookiePolicyVersionNo = 3. This is the default so no settings need to be set in the initialise example below.

*/

document.addEventListener("DOMContentLoaded", function () {

    if (document.getElementById("CookiePolicyAcceptAll") !== null) {
        document.getElementById("CookiePolicyAcceptAll").onclick = function () {
            var date = new Date();
            date.setTime(date.getTime() + (90 * 24 * 60 * 60 * 1000));
            document.cookie = "rtCookiePrivacySetting=AcceptedTypes=ALL; expires=" + date.toUTCString() + "; SameSite=Lax; path=/;";

            document.getElementById("CookiePolicy").style.display = 'none';
            if (document.getElementById("CookiePolicyModal") !== null) { document.getElementById("CookiePolicyModal").style.display = 'none'; }
        };
    }

    if (document.getElementById("CookieControlCentre") !== null) {
        document.getElementById("CookieControlCentre").onclick = function () {
            document.getElementById("CookiePolicy").style.display = 'none';
            if (document.getElementById("CookiePolicyModal") !== null) { document.getElementById("CookiePolicyModal").style.display = 'none'; }
        };
    }
});

/**
 * Opens the Cookie Control Centre in a SweetAlert2 popup.
 * @param {string} [url="/CookieControlCentre"] - The iframe URL to load.
 */
function openCookieControlCentre(url = "/CookieControlCentre") {

    // Select all matching elements
    document.querySelectorAll("#CookieControlCentre, .CookieControlCentreFooter")
        .forEach(btn => {
            btn.addEventListener("click", e => {
                e.preventDefault();

                Swal.fire({
                    title: "Cookie Control Centre",
                    html: `
            <iframe 
              src="${url}" 
              title="Cookie Control Centre" 
              frameborder="0" 
              scrolling="yes" 
              style="width:100%;height:100%;min-height:200px;">
            </iframe>`,
                    width: "80%",
                    heightAuto: false,
                    showConfirmButton: false,
                    showCloseButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: function (el) {
                        const popup = el.querySelector(".swal2-popup");

                        // Accessibility: warn if no title
                        if (popup && !popup.querySelector(".swal2-title")) {
                            console.warn("SweetAlert2 popup missing a title � please set one for accessibility.");
                        }

                        // Ensure iframe has a title
                        const iframe = el.querySelector("iframe");
                        if (iframe && !iframe.title) {
                            iframe.title = "Cookie Control Centre";
                        }

                        // Focus first interactive element
                        const first = popup && popup.querySelector("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
                        if (first) {
                            first.focus();
                        } else {
                            const closeX = popup && popup.querySelector(".swal2-close");
                            if (closeX) closeX.focus();
                        }
                    },
                    didClose: () => {
                        // Return focus to previously active element
                        if (window.__rtLastFocusSelector) {
                            const el = document.querySelector(window.__rtLastFocusSelector);
                            if (el) el.focus();
                        }
                    }
                });
            });
        });
}
